export default __webpack_public_path__ + "static/media/mockup_transparent.54df41d5.png";